export default "__VITE_ASSET__CEixlipl__"